import React from 'react';
import { useForm } from '@inertiajs/react';
import Button from '@/Components/Button';
import useRoute from '@/Hooks/useRoute';
import IconLoading from '@/svgs/pending-ellipse.svg?react';

export default function CommentSubmit({ fileId }: { fileId: string }) {
  const route = useRoute();
  const form = useForm({
    parent_id: null,
    comment: '',
  });
  function saveComment(e: React.FormEvent) {
    e.preventDefault();
    form.post(
      route('files.comment', {
        file: fileId,
      }),
      {
        preserveState: false,
        preserveScroll: true,
        onBefore: () => {
          form.setData('comment', '');
        },
      },
    );
  }

  function handleKeyPress(event: React.KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      saveComment(event);
    }
  }

  return (
    <>
      <form
        onSubmit={saveComment}
        className="p-4 dark:bg-brand-dark-50 rounded-lg shadow-lg"
      >
        <textarea
          value={form.data.comment}
          onChange={e => form.setData('comment', e.currentTarget.value)}
          onKeyDown={handleKeyPress}
          className="w-full h-20 text-lg resize-none border-none bg-brand-75 p-0 placeholder:text-brand-dark-100/40 focus:caret-brand focus:ring-0 dark:bg-transparent dark:text-brand-light-100 placeholder:dark:text-brand-light-25 focus:dark:caret-brand-dark disabled:dark:text-brand-light-25"
          placeholder="Leave a comment..."
        ></textarea>
        <div className="mt-2 flex justify-end">
          <Button type="submit" styleType="primary">
            {form.processing ? <IconLoading /> : 'Comment'}
          </Button>
        </div>
      </form>
    </>
  );
}
